<template>
    <div class="pg-answer-site"
        ref="home"
        :class="{'with-bg': baseStyle && (baseStyle.bgSrc || baseStyle.color)}"
        :style="style"
    >
        <div class="container"
            :style="{background: baseStyle && (baseStyle.bgSrc || baseStyle.color) && baseStyle.opacity >= 0 ? 'rgba(255, 255, 255, ' + baseStyle.opacity/100 + ')' : '#fff'}">
            <img :src="baseStyle.header" class="header_img" width="100%" v-if="baseStyle && baseStyle.header">
            <div class="survey_cover_text">
                <div class="TopBgTitle">
                    <p>{{base.title}}</p>
                </div>
                <div class="desc_begin" v-html="base.desc"></div>
                <div class="wjhr"></div>
                <div class="user" v-if="base.logintype == 1 && account">
                    <span class="username">欢迎您，{{account}}</span>
                    <i class="el-icon-switch-button" @click="logout"></i>
                </div>
            </div>
            <div class="questions">
                <QuestionSite
                    :data="item"
                    v-on:itemClick="itemOnClick"
                    v-on:contentUpdate="contentOnUpdate"
                    v-on:itemContentUpdate="itemContentUpdate"
                    v-for="(item, index) in questions"
                    :textColor="style.color || 'rgb(68, 131, 193)'"
                    :optionColor="baseStyle.optionColor"
                    :optionHighlightColor="baseStyle.optionHighlightColor"
                    :key="index"
                    :sort="index + 1"
                ></QuestionSite>
            </div>
            <el-button class="submmit" @click="submit()" type="primary">提交</el-button>
            <!-- <div class="submmit">提交</div> -->
            <div class="tail"></div>
        </div>
        <!-- <Login v-if="showLogin"></Login> -->
    </div>
</template>
<script>
  import Vue from 'vue';
//   import Login from '~/components/LoginSite/login.vue';
  import QuestionSite from '~/components/QuestionSite/question.vue';
  import api from '~/siteApi/api';
  import { getParameterByName, getUrlParams } from '~/tools/utils';
  import ElementUI from 'element-ui';
  import 'element-ui/lib/theme-chalk/index.css';
  import DeviceDetector from "device-detector-js";
  import { isMobile } from '~/tools/utils';
//   import 'amfe-flexible';

  Vue.use(ElementUI);

  export default {
    components: {
        QuestionSite
    },
    data () {
        return {
            isInIFrame: getParameterByName('iframe'),
            questions: null,
            base: {

            },
            baseStyle: {},
            style: {
                background: '#fff'
            },
            account: '',
            glogin: null,
            showLogin: false,
            starttime: null
        }
    },
    mounted() {
        let _this = this;
        if(isMobile()) {
            location.replace(location.href.replace(/\/site\//, "/"))
        }
        window.addEventListener('message', event => {
            console.log('postMessage' + JSON.stringify(event.data));
            if(event.data == 'refresh') {
                this.init();
            }
        });
        if(!this.isInIFrame && process.env.VUE_APP_ENV !== 'development') {
            requirejs(['login/index'], gLogin => {
                _this.glogin = new gLogin({
                    type:'popup',
                    //设置 去注册按钮
                    fastreg:{
                        //注意：不支持回调函数
                        type: 'normal'
                    },
                    login_type: 27,
                    onLogin: function(result) {
                        if(result){
                            //登录成功
                            api.login({
                                sid: _this.$route.params.sid
                            }).then(res => {
                                if(!res) return;
                                _this.account = res.data.account;
                                if(res.replycount == 1) {
                                    _this.$alert('您已参加过该问卷调查哦，感谢您的参与~', '提示', {
                                        confirmButtonText: '确定'
                                    });
                                }
                            });
                        } else{
                            //登录失败
                            _this.$alert(result.msg, '提示', {
                                confirmButtonText: '确定'
                            });
                        }
                    },
                    onLogout:function(result){
                        if(!!result&&!!result.status&&result.status>0){
                            //注销成功
                        }
                        else{
                            //注销失败
                            _this.$alert(result.msg, '提示', {
                                confirmButtonText: '确定'
                            });
                        }
                    }
                });
            });
        }
        this.init();
    },
    watch: {
        glogin(val) {
            if(this.base.logintype == 1 && !this.account) {
                val.login();
            }
        }
    },
    methods: {
      shuffle(arr) {
        var len = arr.length;
        for(var i=0;i<len;i++){
            var end = len - 1 ;
            var index = (Math.random()*(end + 1)) >> 0;
            var t = arr[end];
            arr[end] = arr[index];
            arr[index] = t;
        }
        return arr;
      },
      logout() {
          this.$confirm('确认要登出吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            return api.logout(this.$route.params.sid)
          }).then(res => {
              if(!res) return;
              this.account = '';
              if(!this.isInIFrame && this.base.logintype == 1) {
                  this.glogin.login();
              }
          });
      },
      init() {
          let _this = this;
          api.getInfo(this.$route.params.sid).then(res => {
              if(!res) return;
              if(res.data.unorder == 1) {
                  _this.questionsAll = _this.shuffle(JSON.parse(JSON.stringify(res.question)));
              } else {
                  _this.questionsAll = JSON.parse(JSON.stringify(res.question));
              }
              _this.questionsAll = _this.questionsAll.map(x => {
                  if(x.qtype == 2 && x.unorder == 1) {
                      x.options = _this.shuffle(JSON.parse(JSON.stringify(x.options)));
                  }
                  return x;
              });
              res.data.desc = res.data.desc.replace(/\n/g, "<br/>")
              _this.base = Object.assign({}, res.data);
              _this.baseStyle = Object.assign({}, res.data.style);
              _this.logics = res.logics;
            //   if(_this.logics.length > 0) {
            //     let target_qid_arr = _this.logics.reduce((a, b) => {
            //         return {target_qid: `${a.target_qid},${b.target_qid}`}
            //     }).target_qid.split(",");
            //     target_qid_arr.forEach(x => {
            //         let matchedIndex = _this.questionsAll.findIndex(q => q.qid == x)
            //         _this.questionsAll[matchedIndex].hide = true;
            //     })
            //   }
              _this.questions = JSON.parse(JSON.stringify(_this.questionsAll));
              let style = _this.baseStyle;

              if (style) {
                  if (style.bgSrc) {
                      _this.style = Object.assign({}, {
                        background: `url(${style.bgSrc})`,
                        backgroundSize: 'cover'
                      });
                  } else if (style.color) {
                      _this.style = Object.assign({}, {
                        background: style.color
                      });
                  }
                  if (style.textColor) {
                      _this.style = Object.assign({}, _this.style, {
                        color: style.textColor
                      });
                  }
                  this.$refs.home.style.width = style.width + 'px';
              }
              if(res.user) {
                  _this.account = res.user.account;
                  _this.starttime = res.user.starttime;
              }
              if(!_this.isInIFrame && (_this.base.logintype == 2 || _this.base.logintype == 5) ) {
                  let params = getUrlParams();
                  return api.login(Object.assign(params, {
                    sid: this.$route.params.sid
                  })).then(res => {
                    if(!res) return;
                    _this.account = res.data.account;
                    if (res.errors && res.errors.error_message) {
                        _this.$alert(res.errors.error_message[0], '提示', {
                            confirmButtonText: '确定'
                        });
                        return;
                    }
                    if(res.replycount == 1) {
                        _this.$alert('您已参加过该问卷调查哦，感谢您的参与~', '提示', {
                            confirmButtonText: '确定'
                        });
                    }
                  });
              }
          });
      },
      itemContentUpdate(indexData) {
          let questionData = this.questionsAll.find(q => q.qid == indexData.qid);
          this.questionsAll = this.questionsAll.map((item) => {
            item.selected = item.qid == indexData.qid ? true : false;
            return item;
          });

          if(indexData.qtype == 2) {
              // 多选题
              questionData.options = questionData.options.map((item, index) => {
                if(index == indexData.index) {
                    item.text = indexData.text;
                }
                return item;
              });
          } else if(/^[1|4|5]/.test(indexData.qtype)) {
            // 单选题
            questionData.options = questionData.options.map((item) => {
              item.text = indexData.text;
              return item;
            });
          }
          this.questions = JSON.parse(JSON.stringify(this.questionsAll)).filter(q => !q.hide);
      },
      itemOnClick(indexData) {
          let questionData = this.questionsAll.find(q => q.qid == indexData.qid);
          this.questionsAll = this.questionsAll.map((item) => {
            item.selected = item.qid == indexData.qid ? true : false;
            return item;
          });

          if(indexData.qtype == 2) {
              // 多选题
              let currentState = questionData.options.find((item, index) => index == indexData.index).selected;
              let selectedNum = questionData.options.filter(item => item.selected).length;
              if(!currentState && selectedNum === parseInt(questionData.maxnum)) {
                this.$alert(`该题请至多选择${questionData.maxnum}项哦~`, '提示', {
                    confirmButtonText: '确定'
                });
                return;
              }
              questionData.options = questionData.options.map((item, index) => {
                if(index == indexData.index) {
                    item.selected = !item.selected;
                }
                return item;
              });
              this.resetQuestions(questionData, indexData.index);
          } else if(/^[1|4|5]/.test(indexData.qtype)) {
            // 单选题
            questionData.options = questionData.options.map((item, index) => {
              item.selected = index == indexData.index ? true : false;
              return item;
            });
            questionData.options.forEach((item, index) => {
                this.resetQuestions(questionData, index);
            })
          } else if(indexData.qtype == 6) {
              // 多选题
              questionData.rows[indexData.dIndex].val = indexData.index;
          }
          this.questions = JSON.parse(JSON.stringify(this.questionsAll)).filter(q => !q.hide);
      },
      contentOnUpdate(indexData) {
          let questionData = this.questionsAll.find(q => q.qid == indexData.qid);
          questionData.content = indexData.content;
          this.questions = JSON.parse(JSON.stringify(this.questionsAll)).filter(q => !q.hide);
      },
      resetQuestions(src, index) {
        let _this = this;
        this.logics.forEach(item => {
            if(item.qid == src.qid && src.options[index].oid == item.qoid) {
                let toBeDeletedQID = item.target_qid.split(',');
                toBeDeletedQID.forEach(x => {
                    let matchedIndex = _this.questionsAll.findIndex(q => q.qid == x)
                    _this.questionsAll[matchedIndex].hide = src.options[index].selected ? true : false;
                });
            }
        })
      },
      checkForm() {
          for (let index = 0; index < this.questions.length; index++) {
              const element = this.questions[index];
              if(/^[1|4|5]/.test(element.qtype)) {
                  let matchedIndex = element.options.findIndex(item => item.selected);
                  if(element.required == 1) {
                      if(matchedIndex == -1) {
                          this.$alert(`请回答第${index + 1}题哦~`, '提示', {
                            confirmButtonText: '确定'
                          });
                          return false;
                      }
                      // 其他项必填且未填时，校验失败
                      if(element.options[matchedIndex].remark == 1 &&
                        element.options[matchedIndex].content_required == 1 &&
                        !element.options[matchedIndex].text
                      ) {
                          this.$alert(`请填写第${index + 1}题的第${matchedIndex + 1}个选项哦~`, '提示', {
                            confirmButtonText: '确定'
                          });
                          return false;
                      }
                  }
              } else if(/^2/.test(element.qtype)) {
                  let matchedItems = element.options.filter(item => item.selected);
                  if(element.required == 1) {
                      if(!matchedItems.length) {
                          this.$alert(`请回答第${index + 1}题哦~`, '提示', {
                            confirmButtonText: '确定'
                          });
                          return false;
                      }
                      if(matchedItems.length < parseInt(element.minnum)) {
                          this.$alert(`第${index + 1}题请至少选择${element.minnum}项哦~`, '提示', {
                            confirmButtonText: '确定'
                          });
                          return false;
                      }
                      if(matchedItems.length > parseInt(element.maxnum)) {
                          this.$alert(`第${index + 1}题请至多选择${element.maxnum}项哦~`, '提示', {
                            confirmButtonText: '确定'
                          });
                          return false;
                      }
                      for (let j = 0; j < matchedItems.length; j++) {
                          const ele = matchedItems[j];
                          // 其他项必填且未填时，校验失败
                          if(ele.remark == 1 &&
                              ele.content_required == 1 &&
                              !ele.text
                          ) {
                              this.$alert(`请填写第${index + 1}题的选项哦~`, '提示', {
                                confirmButtonText: '确定'
                              });
                              return false;
                          }
                      }
                  }
              } else if(/^6/.test(element.qtype)) {
                  //TODO:
              } else if(element.required == 1) {
                  if(!element.content) {
                      this.$alert(`请回答第${index + 1}题哦~`, '提示', {
                        confirmButtonText: '确定'
                      });
                      return false;
                  }
                  if((element.qtype == 3 || element.qtype == 307) &&
                    parseInt(element.alength) > 0 &&
                    element.content &&
                    this.getCharLength(element.content) > parseInt(element.alength)
                  ) {
                      this.$alert(`第${index + 1}题超过字数限制哦`, '提示', {
                        confirmButtonText: '确定'
                      });
                      return false;
                  }
              }
          }
          return true;
      },
      getCharLength(str) {
        //获得字符串实际长度，中文2，英文1
        //要获得长度的字符串
        var realLength = 0, len = str.length, charCode = -1;
        for (var i = 0; i < len; i++) {
            charCode = str.charCodeAt(i);
            if (charCode >= 0 && charCode <= 128)
            realLength += 1;
            else
            realLength += 2;
        }
        return realLength;
      },
      submit() {
          if(!this.checkForm()) {
              return;
          }
          let data = [];
          this.questions.forEach((x) => {
              if(/^[1|4|5]/.test(x.qtype)) {
                  let matchedItem = x.options.find(item => item.selected);
                  data.push({
                      qid: x.qid, oid: matchedItem.oid, content: matchedItem.remark == 1 ? matchedItem.text : matchedItem.content
                  });
              } else if (/^2/.test(x.qtype)) {
                  let matchedItems = x.options.filter(item => item.selected);
                  matchedItems.forEach(item => {
                      data.push({
                        qid: x.qid, oid: item.oid, content: item.remark == 1 ? item.text : item.content
                      });
                  });
              } else if (/^6/.test(x.qtype))  {
                  x.rows.forEach(item => {
                      if(item.val >= 0) {
                          data.push({
                            qid: x.qid,
                            rid: item.rid,
                            oid: x.options[item.val].oid
                          });
                      }
                  })
              } else {
                  data.push({
                      qid: x.qid,
                      content: x.content
                  });
              }
          });
          const deviceDetector = new DeviceDetector();
          const device = deviceDetector.parse(window.navigator.userAgent);
          if(device.device && device.device.model === 'LIO-AN00') {
              device.device.model = 'Mate 30 Pro(5G)'
          }
          api.submit(
              this.$route.params.sid,
              data,
              this.starttime,
              JSON.stringify(device)
          ).then(res => {
              if(res) {
                  this.$alert(this.base.endmsg, '提示', {
                    confirmButtonText: '确定'
                  }).then(() => {
                      if(res.redirecturl) {
                          location.href = res.redirecturl;
                      }
                      if(res.callbackmsg) {
                          redirectTo(res.callbackmsg)
                      }
                  });
                  console.log("surveyfinish"); // 不能删除，客户端会监听console.log
              }
          });
      }
    }
  }
</script>
<style rel="stylesheet/stylus" lang="stylus">
@import '../../assets/stylus/minixs/_center.styl';
    .pg-answer-site
        position relative
        width 1150px
        margin 0 auto
        height 100%
        color: #484848;
        &.with-bg {
            padding 10px;
        }
        .container
            width 100%
            height 100%
            .survey_cover_text
                margin: 0 50px;
                padding: 30px 0 12px;
                background-color: transparent;
                box-shadow: none;
                .TopBgTitle
                    font-size: 18px;
                    font-weight: 300;
                    text-align: center;
                .desc_begin
                    font-size: 16px;
                    line-height 1.5
                    margin: 20px 0 0;
                .wjhr
                    background-color: #53a4f4!important;
                    width: 100%;
                    height: 3px;
                    margin-top: 20px;
                .user {
                    float right
                    margin-top  20px
                    .username {
                        margin-right 10px
                    }
                    i {
                        &:hover {
                            color red
                        }
                    }
                }
            .questions
                width 100%
                padding 0 50px
                display flex
                flex-direction column
                justify-content center
            .submmit
                margin-top 90px
                margin-left 56px
                text-decoration: none;
                width: 80px;
                border-radius: 4px;
                letter-spacing 10px;
                cursor: pointer;
                box-shadow: 0 2px 4px rgba(0, 0, 0, 0.07);
            .tail
                height 30px;
                width 100%
</style>
